(function() {
    'use strict';

    var FtcExtensionCtrl = function($scope, $compile, $uibModalInstance, ajaxCall, passedModel, xmsNotificationFactory, $filter) {

        if( !angular.isDefined(passedModel) ){
            passedModel = {}; // otherwise any ng-init inside modal will create the model in it's own child scope (inaccessible)
        }

        $scope.extendFtcModel = passedModel;
        $scope.disableSubmit = false;
        $scope.fnExtendFtcBooking = function($event) {
            $scope.disableSubmit = true;
            $event.preventDefault();
            var ajaxUrl = WEBAPP_PATH + "/booking/submitFtcExtension?";
            var data = $scope.extendFtcModel;
               console.log("IN fnExtendFtcBooking=====================")
            console.log(data)
            ajaxCall.getData(ajaxUrl, data).then(
                function(result) {
                    $scope.disableSubmit = false;
                    xmsNotificationFactory.addObj({id: "ftcExtensionPop", type: result.data.responseType, bodyHtml: result.data.responseMessage, timeout:10});
                    $uibModalInstance.close($scope.extendFtcModel);
                },
                function(result) {
                    $scope.disableSubmit = false;
                    var alertMessage = "Error occurred. Please try again later..";
                    xmsNotificationFactory.addObj({id: "ftcExtensionPop", type: "danger", bodyHtml: alertMessage, timeout:10});
                    $uibModalInstance.close($scope.extendFtcModel);
                }
            );

            $event.preventDefault();
        }

       $scope.fnChangeFtcEndDate = function(){
            console.log("INSIDE fnChangeFtcEndDate"+$scope.extendFtcModel.ftcDurtionTypeLookupVal+$filter('date')($scope.extendFtcModel.startDate, "dd/MM/yyyy"));
            var ajaxUrl = WEBAPP_PATH + "/item/updateFtcEndDate?ftcDuration="+$scope.extendFtcModel.ftcDurtionTypeLookupVal+"&startDate="+$filter('date')($scope.extendFtcModel.startDate, "yyyy-MM-dd");
             ajaxCall.getData(ajaxUrl).then(
                function(result) {
                    if (result.data.success) {
                        $scope.extendFtcModel.ftcEndDate = new Date(result.data.ftcEndDate);
                        $scope.extendFtcModel.proRatedCharge = result.data.proRatedCharge
                    }
                },
                function(result) {
                }
            );
        }


        $scope.cancelPop = function($event) {
            $event.preventDefault();
            $uibModalInstance.dismiss('cancel');
        }

        $scope.cancel = function() {
           $uibModalInstance.dismiss('cancel');
        }


    }
    FtcExtensionCtrl.$inject = ['$scope', '$compile', '$uibModalInstance','ajaxCall','params','xmsNotificationFactory','$filter'];
    angular.module('app').controller('FtcExtensionCtrl', FtcExtensionCtrl);

}());